import _ from 'lodash';

export default function debounceAction({
  getCurrentValue,
  getIsValid = () => true,
  actionPromise,
  onBeforeAction = () => {},
  onNext = () => {},
  onError = () => {},
  onAfterAction = () => {},
  wait = 500,
  actionDelay = 0,
}) {
  let running = false;
  let lastSavedValue = getCurrentValue();
  let requireResave = false;

  function performAction() {
    if (!getIsValid()) {
      return;
    }

    const currentValue = getCurrentValue();

    // Don't bother performing action if the current value is what was last saved
    if (currentValue === lastSavedValue) {
      return;
    }

    if (running) {
      // Already performing action, shouldn't have multiple simultaneous requests in
      // flight otherwise we could have out of order saves/etc, so trigger another
      // go once the current action successfully completes
      requireResave = true;
      return;
    }

    running = true;
    requireResave = false;

    onBeforeAction();
    setTimeout(
      () => actionPromise()
        .then(result => {
          lastSavedValue = currentValue;
          onNext(result);

          // Only trigger resave on a successful action, otherwise a non-transient
          // error would result in doubled up error messages
          // eslint-disable-next-line no-use-before-define
          requireResave && debounced();
        })
        .catch(onError)
        .finally(() => {
          running = false;
          onAfterAction();
        }),
      actionDelay || 0,
    );
  }

  const debounced = _.debounce(performAction, wait);

  debounced.resetInitialValue = () => (lastSavedValue = getCurrentValue());

  return debounced;
}
